import React from 'react';
import DropdownSearchSelect from '../DropdownSearchSelect';
import { translate } from '../../../../types/translation/Translator';
import { TranslationKey } from '../../../../types/translation/TranslationKey';

export const SupportedLocales = [
  { value: 'en-US', label: 'English (United States)' },
  { value: 'en-GB', label: 'English (United Kingdom)' },
  { value: 'nl-BE', label: 'Dutch (Belgium)' },
  { value: 'nl-NL', label: 'Dutch (Netherlands)' },
  { value: 'de-DE', label: 'German (Germany)' },
  { value: 'fr-FR', label: 'French (France)' },
  { value: 'es-ES', label: 'Spanish (Spain)' },
  { value: 'it-IT', label: 'Italian (Italy)' },
  { value: 'pt-BR', label: 'Portuguese (Brazil)' },
  { value: 'ja-JP', label: 'Japanese (Japan)' },
  { value: 'lt-LT', label: 'Lithuanian (Lithuania)' },
];

type SupportedLocale = (typeof SupportedLocales)[number];

interface LocaleSelectProps {
  locale: string | undefined;
  setLocale: (item: string | undefined) => void;
  tooltip?: string;
}

export default function LocaleSelect({ locale, setLocale, tooltip }: LocaleSelectProps) {
  const selectedLocale = SupportedLocales.find(item => item.value === locale);

  return (
    <DropdownSearchSelect<SupportedLocale>
      tooltip={tooltip}
      placeholder={translate({ key: TranslationKey.selectLocale })}
      label={translate({ key: TranslationKey.locale })}
      items={SupportedLocales}
      value={selectedLocale}
      textBuilder={item => item.label}
      onSelect={item => setLocale(item?.value)}
    />
  );
}
